<template>
	<div id="inbox">

		<div id="previews" v-bind:class="{ showUnreadOnly : $store.state.showUnreadOnly }">
			<div id="carSearch">
				<div class="searchInputWrapper"><input v-model="c_search" v-on:blur="checkifempty" placeholder="Suchen..." v-on:focus="$store.state.activeWindowPartID = '#search'"><i v-if="c_search != ''" v-on:click="empytSearch" class="fa fa-times" aria-hidden="true"></i></div>
			</div>
			
<!--
			<div id="sortOrder">
				<a href="#" class="subjectShow"><i class="fa fa-chevron-down"></i> Anzeigen</a>
				<a href="#" class="sortOrder"><i class="fa fa-chevron-down"></i> Sortierung</a>
			</div>
-->
			
			<div class="scrollbox" v-on:click="$store.state.activeWindowPartID = '#previews'" v-bind:class="{ active : $store.state.activeWindowPartID == '#previews' }">
				<car v-on:delete-car="deleteCar" v-on:complete-car="completeCar" v-for="(car, key, index) in cars.filter( car => { return (car.category_id == $store.state.activeFolder.id || ($store.state.activeFolder.cat_type == 'inbox' && car.category_id == '0')) } ).slice().reverse()" :car.sync="car" :key="car.vorgangsnummer"></car>
			</div>
			<div id="preview_nav">
				<ul>
					<li v-bind:class="{ active: $store.state.showUnreadOnly === true }"><a title="Nur ungelesene E-Mails anzeigen" href="#!" v-on:click="toggleShowUnreadOnly"><i class="fa fa-dot-circle-o" aria-hidden="true"></i></a></li>
				</ul>
			</div>
		</div>
		<div id="details" v-on:click="$store.state.activeWindowPartID = '#details'">
			<car-details v-on:delete-car="deleteCar" v-for="(car, key, index) in cars" :car.sync="car" v-if="car.vorgangsnummer == $store.state.editingCarID " :key="car.id"></car-details>
		</div>	
	</div>
</template>



<script>
import sweetalert from 'sweetalert';	
import Car from '@/components/Cars/Car';	
import CarDetails from '@/components/Cars/CarDetails';	

export default {
	props: ['cars'],

	data() {
    	return { 
	    	c_search:  this.$store.state.searchQuery != '' ?  this.$store.state.searchQuery : '' 
	    	} // then work with localLis in template & methods instead.
  	},

  	components: {
	  	Car,
	  	CarDetails
  	},	
  	computed: {
	  	
  	},
	methods: {	
		
		toggleShowUnreadOnly(e){
			e.preventDefault();
			this.$store.state.showUnreadOnly = this.$store.state.showUnreadOnly ? false : true;
			
			this.$socket.emit('syncCars', { search: this.$store.state.searchQuery, account: this.$store.state.activeAccountID, folder: this.$store.state.activeFolder, unreadOnly: this.$store.state.showUnreadOnly } );
			
		},
				
		carChanged: function(car){
			//console.log('car changed');
			//console.log(car);
		},	
/*
		windowPartClick( el ){
			//e.preventDefault();
			this.$store.state.activeWindowPartID = el;
			//console.log( el )
			//console.log( this.$store.state.activeWindowPartID );
		},
*/
	    deleteCar(car) {
		    
			sweetalert({
			  title: "Echt löschen?",
			  text: "Einmal gelöscht = für immer weg! Kapiert?",
			  icon: "warning",
			  buttons: true,
			  dangerMode: true,
			})
			.then((willDelete) => {
			  if (willDelete) {
				  car.status_id = 99999;
				  this.$socket.emit('deleteCar', { car: car, quiet: 1 } );
			      const carIndex = this.cars.indexOf(car);
			      this.cars.splice(carIndex, 1);
				  this.$store.commit('updateEditingCarID',  this.cars[carIndex].vorgangsnummer )	    
			      
				  //
			 	  
			    sweetalert("Zack!!! Die Karre ist raus!", {
			      icon: "success", 
			      timer: 2000,
			      buttons: false
			    });
			  } else {
/*
			    sweetalert({
				  title: "Oh mann, Junge, noch mal Glück gehabt!",
				  text: " ", 
			      icon: "success", 
			      timer: 2000,
			      buttons: false				  				  
			    }); 
*/
			  }
			});	 
			   
	    },
	    completeCar(car) {
	      const carIndex = this.cars.indexOf(car);
	      this.cars[carIndex].done = true;
	      //sweetalert('Success!', 'To-Do completed!', 'success');
	    },
	    
		checkifempty: function(){
			console.log(  this.c_search );
			if( this.c_search == "" ) this.empytSearch();
		},
		empytSearch: function(){
			this.$store.state.searchQuery = '';
			this.c_search = "";
			this.$emit('search-cars', '' );
		},
		
		checkKeyDown : function(e){		
								
				//console.log(e);				
				//let self = this;
				if(this.$store.state.activeWindowPartID == '#search' && e.keyCode == 13) {
					if( this.c_search != "") {
						this.$store.state.searchQuery = this.c_search;
						this.$emit('search-cars', this.c_search );
					}
				}
												
				if(this.$store.state.activeWindowPartID == '#previews') {
					if(e.keyCode == 8) {
						//console.log(this.CarList);
						this.deleteCar(  this.cars.filter( car => { return car.vorgangsnummer == this.$store.state.editingCarID  })[0]  )
						//this.$children('deleteCar', this.cars.filter( car => { return car.vorgangsnummer == this.$store.state.editingCarID }) );
						}
					if(e.keyCode == 38) {
						e.preventDefault();							
						//console.log('down')
						var c =  this.cars.filter( car => { return car.vorgangsnummer == this.$store.state.editingCarID });	
						var i = this.cars.indexOf( c[0] ) 	//$this.$store.state.editingCarID
						
						if(this.cars[i+1])
						this.$store.commit('updateEditingCarID',  this.cars[i+1].vorgangsnummer )	    
						}
	
					if(e.keyCode == 40) {
						e.preventDefault()
						//console.log('up')
						var c =  this.cars.filter( car => { return car.vorgangsnummer == this.$store.state.editingCarID });	
						var i = this.cars.indexOf( c[0] ) 	//$this.$store.state.editingCarID
						
						if(this.cars[Math.max(i-1,0)])
						this.$store.commit('updateEditingCarID',  this.cars[Math.max(i-1,0)].vorgangsnummer )	    
						}
				}
		}
	    
	    
	    
  	},
	created: function(){		
		var $this = this;			
		//$(window).on('keydown', function(e){			  
		window.addEventListener('keydown', this.checkKeyDown)
	},
	destroyed: function() {
		window.removeEventListener('keydown', this.checkKeyDown)
	},
  	
  
}
</script>